import React from 'react'
import { useSelector } from 'react-redux'

import {
  CAvatar,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react-pro'
import { cilAccountLogout } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { logout } from '../../services/auth'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import defaultAvatar from '../../assets/images/avatar.png'
import './AppHeaderDropdown.scss'

const AppHeaderDropdown = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { short_name, avatar, contest } = useSelector((state) => state.profile)

  const handleLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="d-flex align-items-center gap-1">
      {/* <I18nDropdown /> */}

      <div className="d-flex flex-column align-items-end profile-info">
        <strong className="text-truncate d-inline-block">{short_name}</strong>
        <span className="text-muted fw-normal text-xs">{contest}</span>
      </div>

      <CDropdown variant="nav-item" alignment="end">
        <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
          <CAvatar src={avatar || defaultAvatar} size="md" />
        </CDropdownToggle>
        <CDropdownMenu>
          {/* <CDropdownItem href="/#/profile">
            <CIcon icon={cilUser} className="me-2" />
            {t('Profile')}
          </CDropdownItem>
          <CDropdownDivider /> */}
          <CDropdownItem onClick={() => handleLogout()} style={{ cursor: 'pointer' }}>
            <CIcon icon={cilAccountLogout} className="me-2" />
            {t('Logout')}
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
    </div>
  )
}

export default AppHeaderDropdown
